<template>
  <grid-x col="1fr 1fr" rows="1fr" gap="2em">
    <div class="col-1">
      <h3>Pages</h3>
      <page-list ref="pageList" :data-pages="pages" @page-data="selectPageSEO($event)"></page-list>
    </div>
    <div class="col-2">
      <h3>Manage SEO / Header Tags</h3>
      <p v-if="selected.page">Selected Page: {{this.selected.page}}</p>
      <p v-if="selected.tag">Selected Tag: {{this.selected.tag}}</p>
      <div v-if="!currentPageSEO.disable">
        <seo-tag-input v-model="currentPageSEO"/>
        <button v-if="!editTagSEO" v-on:click="savePageSEO()">Save</button>
        <button v-if="editTagSEO" @click="updateSearchedTag">Save</button>
      </div>

    </div>
    <div class="col-1">
      <h3>Tags</h3>
      <div v-if="currentPageSEO.disable">
        <h4>New Tag</h4>
        <input type="text" placeholder="Tag" v-model="newTag">
        <button @click="createTagSeo()">Create</button>
      </div>
      <div class="dropdown">
        <search-dropdown
          @value="getDropdownQuery"
          placeholder="Please Search For Tag"
          :options="tags"
        ></search-dropdown>
      </div>
    </div>
  </grid-x>
</template>

<script>
import firebase from "firebase";
require("firebase/firestore");
var firestore;
import pageList from "../widgets/pageList";
import gridX from "../widgets/gridX";
import seoTagInput from "../widgets/seoTagInput";
import SearchDropdown from "../common/atoms/SearchDropdown";

export default {
  props: ["pages"],
  components: {
    pageList,
    gridX,
    seoTagInput,
    SearchDropdown
  },
  data: function() {
    firestore = firebase.firestore();
    return {
      storage: firebase.storage(),
      pageSEO: {
        title: "",
        description: "",
        socialImage: ""
      },
      selected: {
        page: "",
        tag: ""
      },
      newTag: "",
      currentPageSEO: {
        disable: true
      },
      searchTagSEO: {},
      db: firebase.firestore(),
      search: "",
      editTagSEO: false,
      tags: []
    };
  },
  firestore() {
    return {
      pages: firestore.collection("pages"),
    };
  },
  mounted() {
    this.getSEOTags();
  },
  methods: {
    getDropdownQuery(query) {
      if (query) {
        this.searchTags(query);
      }
    },
    activeClass: function(a, b) {
      if (a == b) return "active";
      return "";
    },
    getSEOTags: function() {
      const seoTagsRef = this.db
        .collection("seo")
        .doc("tags")
        .collection("meta");
      seoTagsRef.get().then(item => {
        const allTags = item.docs.map(tag => {
  
          return tag.id;
        });
        this.tags = [...allTags];
      });
    },
    selectPageSEO: function(item) {
      this.editTagSEO = false;
      var key = item[".key"];
      this.$binding(
        "currentPageSEO",
        firebase
          .firestore()
          .collection("pages")
          .doc(key)
      );
      this.currentPageKey = key;
      this.selected.page = item.name;
      this.selected.tag = "";
      this.search = "";
      this.currentPageSEO.disable = false;
    },
    savePageSEO: function() {
      var updateObj = {
        seoTitle: "",
        seoDescription: "",
        socialImage: ""
      };
      if (this.currentPageSEO.seoTitle)
        updateObj.seoTitle = this.currentPageSEO.seoTitle;
      if (this.currentPageSEO.seoDescription)
        updateObj.seoDescription = this.currentPageSEO.seoDescription;
      if (this.currentPageSEO.socialImage)
        updateObj.socialImage = this.currentPageSEO.socialImage;

      this.$firestore.currentPageSEO.update(updateObj).then(() => {
        console.log("Document successfully updated!");
        this.currentPageSEO = {};
        this.selected.page = "";
        this.currentPageSEO.disable = true;
      });
    },
    updateSearchedTag: function() {
      this.db
        .collection("seo")
        .doc("tags")
        .collection("meta")
        .doc(`${this.search || this.selected.tag}`)
        .set({
          seoTitle: this.currentPageSEO.seoTitle,
          seoDescription: this.currentPageSEO.seoDescription,
          seoImage: this.currentPageSEO.seoImage
        })
        .then(() => {
          console.log("Document successfully written!");
          this.search = "";
          this.currentPageSEO = {};
          this.selected.tag = "";
          this.currentPageSEO.disable = true;
          this.getSEOTags();
        })
        .catch(error => {
          console.error("Error writing document: ", error);
        });
    },
    createTagSeo: function() {
          this.selected.tag = this.newTag;
          this.newTag = "";
          this.currentPageSEO = {
            seoTitle: "",
            seoDescription: "",
            seoImage: ""
          };
          this.editTagSEO = true;
          this.currentPageSEO.disable = false;
    },
    searchTags: function(query) {
      console.log(query);
      this.$refs.pageList.page = "";
      this.editTagSEO = true;
      this.selected.page = "";
      const lowerCasedQuery = query.toLowerCase();
      const seoTagsRef = this.db
        .collection("seo")
        .doc("tags")
        .collection("meta");
      seoTagsRef
        .doc(`${lowerCasedQuery}`)
        .get()
        .then(item => {
          this.selected.tag = lowerCasedQuery;
          this.currentPageSEO = item.data();
          this.currentPageSEO.disable = false;
        })
        .catch(error => {
          console.error("Error writing document: ", error);
        });
    }
  }
};
</script>
<style scoped>
.dropdown {
  margin: 1em 0;
  width: 90%;
}
</style>




// WEBPACK FOOTER //
// seo.vue?d1d4950a